/* NETRIVA theme JS - cart drawer, pack selector, custom dropdowns, buy bar, launch pop-up */
(function(){
'use strict';

/* Inbound mail is forwarded: we display support@netriva.net but link the working inbox. */
var MAIL_INBOX = 'netrivaltd@gmail.com';

var moneyFmt = function(cents, cur){
  try { return new Intl.NumberFormat('en-GB',{style:'currency',currency:cur||'GBP'}).format(cents/100); }
  catch(e){ return '£'+(cents/100).toFixed(2); }
};

function qs(s,el){return (el||document).querySelector(s)}
function qsa(s,el){return Array.prototype.slice.call((el||document).querySelectorAll(s))}
function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
  return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

function openDrawer(){ document.body.classList.add('dw-open'); }
function closeDrawer(){ document.body.classList.remove('dw-open'); }
window.netrivaOpenCart = function(e){ if(e)e.preventDefault(); refreshDrawer(true); };

/* Free-shipping goal per currency.
   The delivery profile has ONE threshold per zone: UK free from £30, EU free from €50.
   A shopper only ever sees the zone they are actually in, so showing two milestones
   (the old bar promised "£45 for free EU") was wrong for everyone. */
function shipGoal(cur){
  if(cur === 'GBP') return { target:3000, label:'free UK shipping', cap:'£30 · free UK shipping' };
  if(cur === 'EUR') return { target:5000, label:'free EU shipping', cap:'€50 · free EU shipping' };
  return null;
}

var TRASH = '<svg width="15" height="15" viewBox="0 0 24 24" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16"/><path d="M10 11v6M14 11v6"/><path d="M6 7l1 13a1 1 0 001 1h8a1 1 0 001-1l1-13"/><path d="M9 7V5a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>';

function renderDrawer(cart){
  var items = qs('#dw-items'), foot = qs('#dw-foot'), prog = qs('#dw-prog');
  qsa('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
  if(!items) return;
  if(cart.item_count === 0){
    items.innerHTML = '<div class="dw-empty">Your cart is empty.<br><br><a class="btn btn-green" href="/collections/all">Shop the shampoo</a></div>';
    foot.style.display='none'; prog.innerHTML=''; return;
  }
  foot.style.display='block';
  items.innerHTML = cart.items.map(function(it){
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/,'_180x$1$2') : '';
    return '<div class="dw-i" data-key="'+esc(it.key)+'">'
      + '<div class="dw-i-top">'
      +   '<img src="'+esc(img)+'" alt="" loading="lazy">'
      +   '<div class="t"><b>'+esc(it.product_title)+'</b>'
      +     '<div class="v">'+esc(it.variant_title||'')+'</div></div>'
      +   '<div class="p">'+moneyFmt(it.final_line_price, cart.currency)+'</div>'
      + '</div>'
      + '<div class="dw-i-ctl">'
      +   '<div class="qty">'
      +     '<button type="button" data-dq aria-label="Decrease quantity">−</button>'
      +     '<span class="n" aria-live="polite">'+it.quantity+'</span>'
      +     '<button type="button" data-iq aria-label="Increase quantity">+</button>'
      +   '</div>'
      +   '<button type="button" class="rmb" data-rm aria-label="Remove '+esc(it.product_title)+'">'+TRASH+'<span>Remove</span></button>'
      + '</div></div>';
  }).join('');
  qs('#dw-total').textContent = moneyFmt(cart.total_price, cart.currency);

  var goal = shipGoal(cart.currency);
  if(goal){
    var t = cart.total_price, msg, pct = Math.min(100, Math.round(t*100/goal.target));
    if(t >= goal.target){ msg = '🎉 <b>' + goal.label.charAt(0).toUpperCase() + goal.label.slice(1) + ' unlocked!</b>'; pct = 100; }
    else { msg = moneyFmt(goal.target - t, cart.currency) + ' more for <b>' + goal.label + '</b>.'; }
    prog.innerHTML = '<div class="prog"><div class="prog-t">'+msg+'</div>'
      + '<div class="prog-bar"><i style="width:'+pct+'%"></i></div>'
      + '<div class="prog-marks"><span></span><span>'+goal.cap+'</span></div></div>';
  } else { prog.innerHTML=''; }

  qsa('.dw-i').forEach(function(row){
    var key=row.getAttribute('data-key'), n=parseInt(qs('.qty .n',row).textContent,10);
    var dq=qs('[data-dq]',row);
    if(n <= 1){ dq.setAttribute('aria-label','Remove item'); }
    qs('[data-iq]',row).onclick=function(){ changeQty(key,n+1); };
    dq.onclick=function(){ changeQty(key,n-1); };
    qs('[data-rm]',row).onclick=function(){ changeQty(key,0); };
  });
}

function refreshDrawer(open){
  fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
    renderDrawer(c); if(open) openDrawer();
  });
}
function changeQty(key,q){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:key,quantity:Math.max(0,q)})})
    .then(function(r){return r.json()}).then(renderDrawer);
}

document.addEventListener('submit', function(e){
  var f = e.target.closest('form[data-ajax-atc]');
  if(!f) return;
  e.preventDefault();
  var btn = qs('[type=submit]', f); if(btn){ btn.disabled=true; }
  fetch('/cart/add.js',{method:'POST',body:new FormData(f)})
    .then(function(r){ if(!r.ok) throw 0; return r.json(); })
    .then(function(){ refreshDrawer(true); })
    .catch(function(){ f.submit(); })
    .finally(function(){ if(btn){ btn.disabled=false; } });
});

/* gallery switcher (shared) */
function showGallery(target){
  var t = qs('#'+target);
  if(!t) return;
  qsa('.gallery-main > div').forEach(function(m){ m.style.display='none'; var v=m.querySelector('video'); if(v) v.pause(); });
  t.style.display='block';
  var v=t.querySelector('video'); if(v){ v.muted=true; v.play().catch(function(){}); }
  qsa('.thumb-b').forEach(function(x){x.classList.toggle('sel', x.getAttribute('data-target')===target)});
}

/* ---------- custom dropdown: replaces the OS-blue native list with brand green ---------- */
function buildSelect(sel){
  if(sel.getAttribute('data-nsel-done')) return;
  sel.setAttribute('data-nsel-done','1');
  var wrap=document.createElement('div'); wrap.className='nsel';
  var btn=document.createElement('button'); btn.type='button'; btn.className='nsel-b';
  var list=document.createElement('ul'); list.className='nsel-l'; list.setAttribute('role','listbox');
  sel.parentNode.insertBefore(wrap, sel);
  wrap.appendChild(sel); wrap.appendChild(btn); wrap.appendChild(list);
  function label(){
    var o=sel.options[sel.selectedIndex];
    btn.innerHTML='';
    var s=document.createElement('span'); s.textContent=o?o.textContent.trim():'';
    var c=document.createElement('i'); c.className='nsel-c';
    btn.appendChild(s); btn.appendChild(c);
  }
  Array.prototype.forEach.call(sel.options,function(o,i){
    var li=document.createElement('li');
    li.textContent=o.textContent.trim();
    li.setAttribute('role','option');
    if(o.selected) li.className='on';
    li.addEventListener('click',function(ev){
      ev.stopPropagation();
      sel.selectedIndex=i;
      qsa('li',list).forEach(function(c){c.classList.remove('on')});
      li.classList.add('on');
      label();
      wrap.classList.remove('open');
      sel.dispatchEvent(new Event('change',{bubbles:true}));
    });
    list.appendChild(li);
  });
  label();
  btn.addEventListener('click',function(ev){
    ev.stopPropagation(); ev.preventDefault();
    qsa('.nsel.open').forEach(function(w){ if(w!==wrap) w.classList.remove('open'); });
    wrap.classList.toggle('open');
  });
}

/* ---------- safe auto-linking of emails / phones in page copy ---------- */
function linkify(root){
  if(!root || !document.createTreeWalker) return;
  var walker=document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode:function(n){
      if(!n.nodeValue || !/[@\d]/.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
      var p=n.parentNode;
      while(p && p!==root){
        var t=p.nodeName;
        if(t==='A'||t==='SCRIPT'||t==='STYLE'||t==='BUTTON') return NodeFilter.FILTER_REJECT;
        p=p.parentNode;
      }
      return NodeFilter.FILTER_ACCEPT;
    }
  });
  var nodes=[],n;
  while((n=walker.nextNode())) nodes.push(n);
  var re=/([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})|(\+44[\s\d]{9,14}\d)/;
  nodes.forEach(function(node){
    var rest=node.nodeValue;
    if(!re.test(rest)) return;
    var frag=document.createDocumentFragment(), m, guard=0;
    while((m=re.exec(rest)) && guard++<40){
      frag.appendChild(document.createTextNode(rest.slice(0,m.index)));
      var a=document.createElement('a');
      a.className='alink'; a.textContent=m[0];
      if(m[1]){
        /* netriva.net addresses are display-only - route them to the inbox that receives mail */
        a.href='mailto:'+(/@netriva\.net$/i.test(m[0]) ? MAIL_INBOX : m[0]);
      } else {
        a.href='tel:'+m[0].replace(/\s/g,'');
      }
      frag.appendChild(a);
      rest=rest.slice(m.index+m[0].length);
    }
    frag.appendChild(document.createTextNode(rest));
    node.parentNode.replaceChild(frag,node);
  });
}

/* ---------- launch-list pop-up ----------
   Once per visitor. A dismissal is remembered for 30 days, a signup forever.
   Never opens while the cart drawer or the mobile menu is open - if someone is
   mid-task, interrupting them costs more than the email is worth. */
function popup(){
  var ov = qs('#nvp');
  if(!ov) return;
  var KEY='nv_pop';
  var store = {
    get:function(){ try{ return JSON.parse(localStorage.getItem(KEY)||'null'); }catch(e){ return null; } },
    set:function(v){ try{ localStorage.setItem(KEY, JSON.stringify(v)); }catch(e){} }
  };
  var st = store.get();
  var subscribed = st && st.s;
  var snoozedUntil = st && st.u ? st.u : 0;

  /* Shopify returns to the page with ?customer_posted=true after the form is accepted. */
  var posted = /[?&]customer_posted=true/.test(location.search);
  if(posted){ store.set({s:1}); }

  var shown=false, armed=true;
  function open(){
    if(shown || !armed) return;
    if(document.body.classList.contains('dw-open')) return;
    var mnav = qs('.mnav'); if(mnav && mnav.classList.contains('open')) return;
    shown=true; ov.hidden=false;
    requestAnimationFrame(function(){ ov.classList.add('on'); });
    var f = qs('input[type=email]', ov); if(f) setTimeout(function(){ try{ f.focus(); }catch(e){} }, 320);
  }
  function close(snooze){
    ov.classList.remove('on');
    setTimeout(function(){ ov.hidden=true; }, 320);
    if(snooze !== false && !store.get()){ store.set({u: Date.now() + 30*24*3600*1000}); }
    else if(snooze !== false){ var c=store.get(); if(!c.s){ store.set({u: Date.now() + 30*24*3600*1000}); } }
  }
  qsa('[data-nvp-close]', ov).forEach(function(b){ b.onclick=function(){ close(true); }; });
  ov.addEventListener('click', function(e){ if(e.target === ov) close(true); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && ov.classList.contains('on')) close(true); });

  if(subscribed) return;

  if(posted){
    var fm=qs('[data-nvp-form]',ov), dn=qs('[data-nvp-done]',ov);
    if(fm && dn){ fm.hidden=true; dn.hidden=false; armed=true; open(); }
    return;
  }

  if(snoozedUntil && Date.now() < snoozedUntil) return;

  /* whichever comes first: leaving the window, 18 seconds, or halfway down the page */
  setTimeout(open, 18000);
  document.addEventListener('mouseout', function(e){
    if(!e.relatedTarget && e.clientY <= 0) open();
  });
  window.addEventListener('scroll', function(){
    var h = document.body.scrollHeight - window.innerHeight;
    if(h > 0 && (window.pageYOffset / h) > 0.5) open();
  }, {passive:true});
}

document.addEventListener('DOMContentLoaded', function(){
  var ov=qs('.dw-ov'), x=qs('.dw-x');
  if(ov) ov.onclick=closeDrawer;
  if(x) x.onclick=closeDrawer;
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ closeDrawer(); qsa('.nsel.open').forEach(function(w){w.classList.remove('open')}); } });
  refreshDrawer(false);

  /* build all custom dropdowns, close them on outside click */
  qsa('select[data-nsel]').forEach(buildSelect);
  document.addEventListener('click',function(){ qsa('.nsel.open').forEach(function(w){w.classList.remove('open')}); });

  /* marquee continuity: duplicate segments until every track fills 2x the viewport */
  qsa('.mq-track').forEach(function(tr){
    var segs=qsa('.mq-seg',tr);
    if(!segs.length) return;
    var guard=0;
    while(tr.scrollWidth < window.innerWidth*2 && guard<6){
      segs.forEach(function(s){ tr.appendChild(s.cloneNode(true)); });
      guard++;
    }
  });

  /* highlight the current page in the header nav */
  var path=location.pathname.replace(/\/$/,'');
  qsa('.nav ul a').forEach(function(a){
    var ap=(a.pathname||'').replace(/\/$/,'');
    if(!ap) return;
    if(ap===path || path.indexOf(ap+'/')===0) a.classList.add('active');
  });

  /* emails + phones become links in page copy */
  qsa('.prose, .cbox').forEach(linkify);

  /* any hand-written netriva.net mailto also routes to the working inbox */
  qsa('a[href^="mailto:"]').forEach(function(a){
    if(/mailto:[^@]+@netriva\.net/i.test(a.getAttribute('href')||'')) a.href='mailto:'+MAIL_INBOX;
  });

  /* pack selector: sync price, stock AND main photo */
  var opts=qsa('.opt[data-vid]');
  if(opts.length){
    var idInput=qs('#buy-variant-id'), priceEl=qs('#buy-price'), shipEl=qs('#buy-ship'),
        atc=qs('#buy-atc'), stockEl=qs('#buy-stock'), bbPrice=qs('#bb-price'), bbShip=qs('#bb-ship');
    function sel(o){
      opts.forEach(function(x){x.classList.remove('sel')});
      o.classList.add('sel');
      var r=qs('input[type=radio]',o); if(r) r.checked=true;
      if(idInput) idInput.value=o.getAttribute('data-vid');
      if(priceEl) priceEl.textContent=o.getAttribute('data-price');
      if(shipEl) shipEl.textContent=o.getAttribute('data-ship');
      if(atc) atc.textContent='Add to cart – '+o.getAttribute('data-price');
      if(stockEl) stockEl.textContent=o.getAttribute('data-stock');
      if(bbPrice) bbPrice.textContent=o.getAttribute('data-price');
      if(bbShip) bbShip.textContent=o.getAttribute('data-ship');
      var g=o.getAttribute('data-gallery'); if(g) showGallery(g);
    }
    opts.forEach(function(o){ o.addEventListener('click',function(){sel(o)}); });
    var pvid=null;
    try{ pvid=new URLSearchParams(location.search).get('variant'); }catch(err){}
    var pre=null;
    if(pvid){ pre=opts.filter(function(o){return o.getAttribute('data-vid')===pvid})[0]||null; }
    if(!pre) pre=qs('.opt.sel')||opts[opts.length-1];
    sel(pre);
  }

  /* homepage pack cards: whole card navigates to product page with variant preselected */
  qsa('.pack[data-url]').forEach(function(card){
    card.addEventListener('click', function(e){
      if(e.target.closest('form') || e.target.closest('a') || e.target.closest('button') || e.target.closest('.nsel')) return;
      location.href = card.getAttribute('data-url');
    });
    card.addEventListener('keydown', function(e){
      if(e.key==='Enter' && e.target===card) location.href = card.getAttribute('data-url');
    });
  });

  /* floating buy bar: after the trigger (or 600px), follows to the very bottom */
  var bar=qs('#buybar'), trig=qs('#buybar-trigger');
  if(bar){
    function upd(){
      var show = trig ? (trig.getBoundingClientRect().bottom < 0) : (window.pageYOffset > 600);
      bar.classList.toggle('show', show);
    }
    window.addEventListener('scroll', upd, {passive:true});
    window.addEventListener('resize', upd);
    upd();
    var bbBtn=qs('#bb-atc');
    if(bbBtn) bbBtn.onclick=function(){ var f=qs('form[data-ajax-atc]'); if(f) f.dispatchEvent(new Event('submit',{cancelable:true,bubbles:true})); };
  }

  /* thumbnails */
  qsa('.thumb-b[data-target]').forEach(function(b){
    b.addEventListener('click',function(){ showGallery(b.getAttribute('data-target')); });
  });

  popup();
});

window.netrivaToggleSnd = function(btn){
  var v = btn.parentElement.querySelector('video');
  if(!v) return;
  v.muted = !v.muted;
  btn.textContent = v.muted ? '🔇 Sound' : '🔊 Sound on';
};
})();
